import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Film } from "@/components/site/Film";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { ShowPilot } from "@/components/site/ShowPilot";
import { Family } from "@/components/site/Family";
import { InvestorDeck } from "@/components/site/InvestorDeck";
import { FAQ } from "@/components/site/FAQ";
import { Contact } from "@/components/site/Contact";
import { scrollTo } from "@/components/site/Reveal";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => scrollTo(hash), 350);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Film />
      <Manifesto />
      <Services />
      <ShowPilot />
      <Family />
      <InvestorDeck />
      <FAQ />
      <Contact />
    </main>
  );
}
